"use client";

import React from "react";
import Icon from "@/components/ui/AppIcon";
import ScrollReveal from "./ScrollReveal";

interface ContactItem {
  id: string;
  icon: string;
  label: string;
  sublabel: string;
  href: string;
  ariaLabel: string;
}

interface ContactLinksProps {
  contacts: ContactItem[];
}

export default function ContactLinks({ contacts }: ContactLinksProps) {
  return (
    <div className="px-4 py-2 space-y-3 sm:px-6">
      {contacts.map((item, index) => (
        <ScrollReveal key={item.id} delay={index * 80}>
          <a
            href={item.href}
            target={item.href.startsWith("http") ? "_blank" : undefined}
            rel={item.href.startsWith("http") ? "noopener noreferrer" : undefined}
            aria-label={item.ariaLabel}
            className="contact-row ripple-container group flex items-center gap-4 p-4 rounded-2xl"
          >
            {/* Icon circle */}
            <div
              className="contact-icon-wrap flex-shrink-0 flex items-center justify-center rounded-full bg-primary text-white transition-all duration-300 ease-out group-hover:scale-110 group-hover:shadow-lg"
              style={{ width: 52, height: 52 }}
            >
              <Icon name={item.icon as any} size={22} variant="solid" className="text-white transition-transform duration-300 group-hover:scale-110" />
            </div>

            {/* Text */}
            <div className="flex-1 min-w-0">
              <div
                className="font-jakarta font-semibold text-primary truncate transition-colors duration-200 group-hover:text-accent"
                style={{ fontSize: "15px" }}
              >
                {item.label}
              </div>
              <div
                className="font-sans text-muted"
                style={{ fontSize: "13px" }}
              >
                {item.sublabel}
              </div>
            </div>

            {/* Arrow */}
            <div className="flex-shrink-0 text-muted transition-all duration-300 ease-out group-hover:text-primary group-hover:translate-x-1">
              <Icon name="ChevronRightIcon" size={18} variant="outline" />
            </div>
          </a>
        </ScrollReveal>
      ))}
    </div>
  );
}